module.exports = __webpack_public_path__ + "static/media/Logo-SEP.87c4d45c.jpg";